const MuiTextField = {
  defaultProps: {
    autoComplete: 'off',
  },
};

export default MuiTextField;
